/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Empty, Form, Skeleton, Input, Select } from 'antd'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import AvatarUplaod from './AvatarUpload'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { form, user_uid, onSubmit } = this.props
		const { getFieldDecorator } = form

		return (
			<Query query={USER_DETAILS} variables={{ user_uid }}>
				{({ loading, error, data }) => {
					if (loading) return <Skeleton active/>
					if (error) return <Empty />

					let userDetails = _.has(data,'userDetailsByUid') ? data.userDetailsByUid : {}
					console.log('userDetails', userDetails)
					return (
						<Form onSubmit={onSubmit}>
							<Row type='flex' justify='center'>
								<Form.Item label=''>
									{ getFieldDecorator('avatar', { 
										rules: [{
											required: false,
											message: 'This field is required.'
										}]
									})
									(
										<AvatarUplaod 
											system_user_uid={user_uid} 
										/>
									)}
								</Form.Item>
							</Row>
							<Row>
								<Form.Item label='Full Name'>
									{ getFieldDecorator('full_name', {
										initialValue: _.has(userDetails, 'full_name') ? userDetails.full_name : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter Full name'/>
									)}
								</Form.Item>
							</Row>
							<Row>
								<Form.Item label='Username'>
									{ getFieldDecorator('username', {
										initialValue: _.has(userDetails, 'username') ? userDetails.username : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter Username'/>
									)}
								</Form.Item>
							</Row>
							<Row>
								<Form.Item label='Email'>
									{ getFieldDecorator('email', {
										initialValue: _.has(userDetails, 'email') ? userDetails.email : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}, {
											validator: (rule, value, callback) => {
												if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
													callback('only white space detected.')
												}
												callback()
											}
										}]
									})
									(
										<Input placeholder='Enter Email address'/>
									)}
								</Form.Item>
							</Row>
							<Row>
								<Form.Item label='Gender'>
									{ getFieldDecorator('gender', {
										initialValue: _.has(userDetails, 'gender') ? userDetails.gender : null,
										rules: [{
											required: true,
											message: 'This field is required.'
										}]
									})
									(
										<Select placeholder='Select Gender'>
											<Select.Option value='Male'>Male</Select.Option>
											<Select.Option value='Female'>Female</Select.Option>
										</Select>
									)}
								</Form.Item>
							</Row>
						</Form>
					)
				}}
			</Query>
		)
	}
}

const USER_DETAILS = gql`
    query userDetailsByUid($user_uid: String) {
		userDetailsByUid(user_uid: $user_uid)
    }
`

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
